import { decodeHexResponse } from '../_common/common.utils';
import ResetPasswordTypes from './ResetPassword.types'; 

const INITIAL_STATE = {
	resetPasswordResponse: null,	
	resetFingerprintResponse: null,	
};

const resetPasswordReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case ResetPasswordTypes.RESET_PASSWORD_START:
			return { ...state, resetPasswordResponse: null };
		case ResetPasswordTypes.RESET_PASSWORD_SUCCESS:
			// Check if response is encrypted (has response field) or plain
			if (action.payload?.response) {
				return { ...state, 
					resetPasswordResponse: decodeHexResponse(action.payload, ResetPasswordTypes.RESET_PASSWORD_KEY) };
			} else {
				// Plain response (shouldn't happen for success, but handle it)
				return { ...state, resetPasswordResponse: action.payload };
			}
		case ResetPasswordTypes.RESET_PASSWORD_FAILURE:
			// Error responses are not encrypted, return as-is
			return {
				...state,
				resetPasswordResponse: action.payload,
			};
		case ResetPasswordTypes.RESET_PASSWORD_RESPONSE_CHANGED:
			return { ...state, resetPasswordResponse: null };
		case ResetPasswordTypes.RESET_PASSWORD_RESPONSE_REST_START:
			return { ...state, resetPasswordResponse: null };
		case ResetPasswordTypes.RESET_FINGERPRINT_START:
			return { ...state, resetFingerprintResponse: null };
		case ResetPasswordTypes.RESET_FINGERPRINT_SUCCESS:
			// Check if response is encrypted (has response field) or plain
			if (action.payload?.response) {
				return { ...state, 
					resetFingerprintResponse: decodeHexResponse(action.payload, ResetPasswordTypes.RESET_FINGERPRINT_KEY) };
			} else {
				// Plain response (shouldn't happen for success, but handle it)
				return { ...state, resetFingerprintResponse: action.payload };
			}
		case ResetPasswordTypes.RESET_FINGERPRINT_FAILURE:
			// Error responses are not encrypted
			return {
				...state,
				resetFingerprintResponse: action.payload,
			};
		case ResetPasswordTypes.RESET_FINGERPRINT_RESPONSE_CHANGED:
			return { ...state, resetFingerprintResponse: null };
		case ResetPasswordTypes.RESET_FINGERPRINT_RESPONSE_REST_START:
			return { ...state, resetFingerprintResponse: null };
		default:
			return state;
	}
};

export default resetPasswordReducer;
